import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { INVENTORY_SET_COLORS } from "./utils";

const fmtD = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

export default function ToolHistoryDialog({ onClose }) {
  const [rows, setRows] = useState(null);
  const [colorFilter, setColorFilter] = useState("all");

  useEffect(() => {
    api.get("/tool-sets/history").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);

  const filtered = (rows || []).filter((r) => colorFilter === "all" || r.color === colorFilter);

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="tool-history-dialog">
        <DialogHeader>
          <DialogTitle>🧰 Istoric scule — pe unde au umblat</DialogTitle>
        </DialogHeader>
        <div className="flex items-center gap-1.5 flex-wrap">
          <button onClick={() => setColorFilter("all")} className={`text-xs px-2.5 py-1 rounded-full border font-semibold ${colorFilter === "all" ? "bg-[var(--primary)] text-white border-[var(--primary)]" : "bg-white border-zinc-300"}`}>Toate</button>
          {INVENTORY_SET_COLORS.map((t) => (
            <button key={t.code} onClick={() => setColorFilter(t.code)}
              className={`text-xs px-2.5 py-1 rounded-full border font-semibold ${colorFilter === t.code ? "text-white" : "bg-white text-zinc-700"}`}
              style={colorFilter === t.code ? { background: t.hex, borderColor: t.hex } : { borderColor: t.hex }}
              data-testid={`tool-hist-filter-${t.code}`}>
              {t.emoji} {t.label}
            </button>
          ))}
        </div>
        <div className="max-h-[55vh] overflow-auto space-y-2 mt-2">
          {rows === null && <div className="text-sm text-zinc-400 italic">Se încarcă...</div>}
          {rows !== null && filtered.length === 0 && (
            <div className="text-sm text-zinc-400 italic border border-dashed border-zinc-300 rounded-md p-4 text-center">
              Niciun istoric încă — se înregistrează automat când aloci scule unui șantier/regie.
            </div>
          )}
          {filtered.map((r) => {
            const t = INVENTORY_SET_COLORS.find((x) => x.code === r.color);
            return (
              <div key={r.id} className="border border-zinc-200 rounded-md p-2.5 flex flex-wrap items-start gap-x-4 gap-y-1" style={{ borderLeft: `5px solid ${t?.hex || "#999"}` }} data-testid={`tool-hist-${r.id}`}>
                <span className="text-xs font-bold px-2 py-0.5 rounded-full text-white" style={{ background: t?.hex }}>{t?.emoji} {t?.label}</span>
                <div className="min-w-[150px]">
                  <div className="font-bold text-sm">{r.label}</div>
                  <div className="text-[11px] text-zinc-500">{fmtD(r.first_day)}{r.last_day && r.last_day !== r.first_day ? ` → ${fmtD(r.last_day)}` : ""}</div>
                </div>
                <div className="text-xs text-zinc-700">
                  {(r.vans || []).length > 0
                    ? <>🚐 {r.vans.join(" · ")}</>
                    : <span className="text-zinc-400 italic">fără dubă înregistrată</span>}
                </div>
              </div>
            );
          })}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="tool-history-close">Închide</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
